export const UPDATE_CHARACTER = 'characters:updateCharacter';

export function updateCharacter(newCharacter) {
  return {
    type: UPDATE_CHARACTER,
    payload: newCharacter
  }
}
